import { Box, Drawer, StatusBadge, styled } from '@driftt/dds'

export const StyledDrawerContent = styled(Drawer.Content, {
  background: '$gray2',
  padding: '$2',
})

export const StyledStatusBadge = styled(StatusBadge, {
  whiteSpace: 'nowrap',
})

export const StyledChatBubble = styled(Box, {
  width: '100%',
  borderRadius: '3px',
  background: '$gray2',
  display: 'flex',
  padding: '8px',
  alignItems: 'flex-start',
  gap: '8px',
  alignSelf: 'stretch',
})
